import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const SnackbarContext = createContext(null);

export function SnackbarProvider({ children }) {
  const [snackbar, setSnackbar] = useState({
    visible: false,
    message: '',
    status: 'success',
  });

  const showSnackbar = useCallback((message, status = 'success') => {
    setSnackbar({ visible: true, message, status });
  }, []);

  useEffect(() => {
    if (!snackbar.visible) return;

    const timer = setTimeout(() => {
      setSnackbar((prev) => ({ ...prev, visible: false }));
    }, 6000);

    return () => clearTimeout(timer);
  }, [snackbar.visible]);

  const value = useMemo(() => ({ showSnackbar }), [showSnackbar]);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {snackbar.visible && (
        <div className="fixed min-w-full bottom-24 z-[9999]">
          <div
            className={`mx-5 text-white px-5 py-3.5 rounded-full shadow-xl text-[0.98rem] max-w-screen text-center transition-opacity duration-200 ease-in-out ${
              snackbar.status === 'error' ? 'bg-rose-accent' : 'bg-[#6A9A75]'
            }`}
          >
            {snackbar.message}
          </div>
        </div>
      )}
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
}
